export class FrameScheduler {
  private running = false
  private processing = false
  private callbackId: number | null = null
  private timerId: number | null = null
  private lastRunAt = 0

  constructor(
    private readonly video: HTMLVideoElement,
    private intervalMs = 250,
  ) {}

  setInterval(intervalMs: number): void {
    this.intervalMs = Math.max(16, intervalMs)
  }

  start(processFrame: (capturedAt: number) => Promise<void>): void {
    if (this.running) return
    this.running = true
    const onFrame = (now: number) => {
      if (!this.running) return
      if (!this.processing && now - this.lastRunAt >= this.intervalMs) {
        this.processing = true
        this.lastRunAt = now
        void processFrame(Date.now()).finally(() => { this.processing = false })
      }
      this.schedule(onFrame)
    }
    this.schedule(onFrame)
  }

  stop(): void {
    this.running = false
    if (this.callbackId !== null) this.video.cancelVideoFrameCallback?.(this.callbackId)
    if (this.timerId !== null) window.clearTimeout(this.timerId)
    this.callbackId = null
    this.timerId = null
  }

  private schedule(callback: (now: number) => void): void {
    if (!this.running) return
    if (this.video.requestVideoFrameCallback) {
      this.callbackId = this.video.requestVideoFrameCallback((now) => callback(now))
    } else {
      this.timerId = window.setTimeout(() => callback(performance.now()), Math.max(16, this.intervalMs / 2))
    }
  }
}
